import request from "@/utils/request1";
import Vue from "vue";
import baseUrl from "@/utils/baseUrl1";

/**
 * 文件服务接口
 */
const fileService = {};

let commonUrl = "file";
fileService.getUrl= function (flieId) {
    return baseUrl.fileWithoutAuth +"/"+ commonUrl + "/download/"+flieId ;
}

export default fileService;
